function filterResultsEvent(filterValue, filterType, itemsCount) {
  dataLayer.push({
    event: 'custom_event',
    event_name: 'filter_results',
    parameter: `{"value": "${filterValue}", "type": "${filterType}", "items_count": "${itemsCount}"}`
  });
}

function filterClick(value, type) {
  dataLayer.push({
    event: 'custom_event',
    event_name: 'filter_click',
    parameter: `{"value":"${value}", "type": "${type}"}`
  });
}

function filterOpen() {
  dataLayer.push({
    event: 'custom_event',
    event_name: 'filter_open',
    parameter: ''
  });
}

function filterClose() {
  dataLayer.push({
    event: 'custom_event',
    event_name: 'filter_close',
    parameter: ''
  });
}

function sortingClick(type) {
  dataLayer.push({
    event: 'custom_event',
    event_name: 'sorting_click',
    parameter: `{"type": "${type}"}`
  });
}

function filterApply() {
  dataLayer.push({
    event: 'custom_event',
    event_name: 'filter_apply',
    parameter: ''
  });
}

function filterResults(value, type, items_count) {
  dataLayer.push({
    event: 'custom_event',
    event_name: 'filter_results',
    parameter: `{"value": "${value}", "type": "${type}", "items_count": "${items_count}"}`
  });
}

document.querySelectorAll('.category_wrap-collectionImg').forEach(link => {
  link.addEventListener('click', function () {
    dataLayer.push({
      event: 'custom_event',
      event_name: 'category_carousel_click',
      parameter: JSON.stringify({
        category_name: this.dataset.categoryName
      })
    });
  });
});

document.querySelectorAll('.collection-categories a').forEach(link => {
  link.addEventListener('click', function () {
    dataLayer.push({
      event: 'custom_event',
      event_name: 'category_carousel_click',
      parameter: JSON.stringify({
        category_name: this.dataset.categoryName
      })
    });
  });
});

document.addEventListener('click', function (event) {
  const facetsDisclosure = event.target.closest('.facets__summary');
  const mobileFacetsDetails = event.target.closest('.mobile-facets__details');

  if (facetsDisclosure) {
    const filterType = facetsDisclosure.closest('details').dataset.filterType;
    dataLayer.push({
      event: 'custom_event',
      event_name: 'filter_expand',
      parameter: `{"type":"${filterType}"}`
    });
  }

  if (mobileFacetsDetails) {
    const filterType = mobileFacetsDetails.dataset.filterType;
    dataLayer.push({
      event: 'custom_event',
      event_name: 'filter_expand',
      parameter: `{"type":"${filterType}"}`
    });
  }
});

document.addEventListener('facets:results-updated', function () {
  const params = new URLSearchParams(window.location.search);
  const productCountElement = document.querySelector(
    '.js-product-grid__count-numer'
  );
  const itemsCount = productCountElement
    ? parseInt(productCountElement.textContent.trim())
    : 0;

  for (const [key, value] of params.entries()) {
    if (key.startsWith('filter.v.option') || key.startsWith('filter.p.')) {
      const type = key.replace('filter.v.option.', '').replace('filter.p.', '');
      const valueFormatted = document
        .querySelector(`input[value="${value}"]`)
        .closest('.facets__item').dataset.filterValue;
      filterResultsEvent(valueFormatted, type, itemsCount);
    }
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const urlParams = new URLSearchParams(window.location.search);
  const appliedFilters = [];

  for (const [key, value] of urlParams.entries()) {
    if (
      key.startsWith('filter.v.option') ||
      key.startsWith('filter.p.product_type')
    ) {
      let formattedValue = document
        .querySelector(`input[value="${value}"]`)
        .closest('.facets__item').dataset.filterValue;
      appliedFilters.push({
        value: formattedValue,
        type: key.replace('filter.v.option.', '').replace('filter.p.', '')
      });
    }
  }

  if (appliedFilters.length > 0) {
    const productCountElement = document.querySelector(
      '.js-product-grid__count-numer'
    );
    const itemsCount = productCountElement
      ? parseInt(productCountElement.textContent.trim())
      : 0;

    appliedFilters.forEach(filter => {
      filterResultsEvent(filter.value, filter.type, itemsCount);
    });
  }
});

const SCROLL_BATCH_SIZE = 6;
let scrollSeenItems = [];
let scrollSeenCount = 0;
let scrollNextMilestone = SCROLL_BATCH_SIZE;
let shouldResetAfterCollectionChange = false;
let collectionScrollObserver;

const getCollectionTotalCount = () => {
  const el = document.querySelector('.js-product-grid__count-numer');
  return el ? parseInt(el.textContent.trim(), 10) || 0 : 0;
};

const fireCollectionScrollEvent = (item_count, total_count) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'custom_event',
    event_name: 'collection_page_scroll',
    parameter: JSON.stringify({
      items_count: String(item_count),
      total_count: String(total_count)
    })
  });
};

const getCollectionObserverThreshold = () => {
  const firstCard = document.querySelector('#ProductGridContainer .grid__item');
  if (!firstCard) return 0.8;

  const cardHeight = firstCard.getBoundingClientRect().height;
  const viewportHeight = window.innerHeight;

  return cardHeight <= viewportHeight ? 0.8 : 0.25;
};

const handleCollectionIntersections = entries => {
  entries.forEach(entry => {
    if (!entry.isIntersecting) return;

    const el = entry.target;
    if (scrollSeenItems.includes(el)) return;

    scrollSeenItems.push(el);
    collectionScrollObserver.unobserve(el);

    scrollSeenCount++;

    if (scrollSeenCount >= scrollNextMilestone) {
      scrollNextMilestone += SCROLL_BATCH_SIZE;
      fireCollectionScrollEvent(scrollSeenCount, getCollectionTotalCount());
    }
  });
};

const createCollectionScrollObserver = () => {
  if (collectionScrollObserver) {
    collectionScrollObserver.disconnect();
  }

  collectionScrollObserver = new IntersectionObserver(
    handleCollectionIntersections,
    { threshold: getCollectionObserverThreshold() }
  );
};

const observeCollectionGridItems = container => {
  container.querySelectorAll('.grid__item').forEach(item => {
    if (!scrollSeenItems.includes(item)) {
      collectionScrollObserver.observe(item);
    }
  });
};
const resetCollectionScrollTracking = grid => {
  scrollSeenItems = [];
  scrollSeenCount = 0;
  scrollNextMilestone = SCROLL_BATCH_SIZE;

  createCollectionScrollObserver();
  observeCollectionGridItems(grid);
};

const attachCollectionGridObserver = () => {
  const grid = document.getElementById('ProductGridContainer');
  if (!grid) return;

  createCollectionScrollObserver();
  observeCollectionGridItems(grid);

  new MutationObserver(() => {
    if (shouldResetAfterCollectionChange) {
      shouldResetAfterCollectionChange = false;
      resetCollectionScrollTracking(grid);
      return;
    }

    observeCollectionGridItems(grid);
  }).observe(grid, {
    childList: true,
    subtree: true
  });

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      createCollectionScrollObserver();
      observeCollectionGridItems(grid);
    }, 150);
  });
};
const wrapHistoryMethod = method => {
  const original = history[method];
  history[method] = function (...args) {
    const result = original.apply(this, args);
    if (document.getElementById('ProductGridContainer')) {
      shouldResetAfterCollectionChange = true;
    }
    return result;
  };
};

wrapHistoryMethod('pushState');

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', attachCollectionGridObserver);
} else {
  attachCollectionGridObserver();
}